module.exports = __webpack_public_path__ + "static/media/empty-state-graph.1fa0e048.svg";